var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.25065V10.3416L12.0837 11.2507M10.0003 18.1257C7.67291 18.1257 6.5092 18.1257 5.5737 17.7983C3.89809 17.212 2.58066 15.8946 1.99434 14.2189C1.66699 13.2834 1.66699 12.1197 1.66699 9.79232C1.66699 7.4649 1.66699 6.30119 1.99434 5.36569C2.58066 3.69008 3.89809 2.37265 5.5737 1.78633C6.5092 1.45898 7.67291 1.45898 10.0003 1.45898C12.3277 1.45898 13.4914 1.45898 14.427 1.78633C16.1026 2.37265 17.42 3.69008 18.0063 5.36569C18.3337 6.30119 18.3337 7.4649 18.3337 9.79232C18.3337 12.1197 18.3337 13.2834 18.0063 14.2189C17.42 15.8946 16.1026 17.212 14.427 17.7983C13.4914 18.1257 12.3277 18.1257 10.0003 18.1257Z",
    stroke: "rgb(229, 71, 70)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutActiveIcon);
export default __webpack_public_path__ + "static/media/LogoutActiveIcon.23fcf70b074244f8a345ed00ac2a4a3c.svg";
export { ForwardRef as ReactComponent };